/** @format */

import { useTranslation } from 'react-i18next';
import search from '../../assets/icon/search.svg';
import useQuery from 'src/hooks/useQuery';
import { useEffect, useRef } from 'react';

export const Search = ({ keyword, onChange, onSubmit }) => {
  const { t } = useTranslation();
  const query = useQuery().get('query');
  const inputRef = useRef();

  const handleOnKeyDown = e => {
    if (e.key === 'Enter' || e.key === 'NumpadEnter') {
      onSubmit();
    }
  };

  useEffect(() => {
    if (query !== null) {
      inputRef.current?.focus();
    }
  }, [query]);

  return (
    <div className="search-component">
      <input
        ref={inputRef}
        value={keyword}
        onChange={onChange}
        onKeyDown={handleOnKeyDown}
        className="search-component-input"
        placeholder={t('Tickets.searchPlaceholder')}
      />
      <button onClick={onSubmit} className="search-component-button">
        <img alt="search button" src={search} />
      </button>
    </div>
  );
};
